/** Checking images before upload. Kept apart from the components so both the submit form
 * and an existing item's strip can use them. */

import { ATTACHMENT_LIMITS } from '@/features/feedback/useFeedback'

/**
 * Checks a batch against the limits the API enforces, so the common mistakes are caught
 * before an upload rather than reported after one. The server still decides.
 */
export function vetImages(
  files: File[],
  alreadyHeld: number,
): { accepted: File[]; problems: string[] } {
  const accepted: File[] = []
  const problems: string[] = []
  for (const file of files) {
    if (!(ATTACHMENT_LIMITS.types as readonly string[]).includes(file.type)) {
      problems.push(`${file.name || 'That file'} is not a PNG or JPEG image.`)
    } else if (file.size > ATTACHMENT_LIMITS.maxBytes) {
      problems.push(`${file.name || 'That image'} is over 5 MB.`)
    } else if (alreadyHeld + accepted.length >= ATTACHMENT_LIMITS.maxPerItem) {
      problems.push(`Up to ${ATTACHMENT_LIMITS.maxPerItem} images per item.`)
      break
    } else {
      accepted.push(file)
    }
  }
  return { accepted, problems }
}

/** Images from a paste event, if it carried any. Text pastes return an empty list. */
export function imagesFromPaste(event: React.ClipboardEvent): File[] {
  return Array.from(event.clipboardData.files).filter((file) => file.type.startsWith('image/'))
}
